import { EllipsisDropdownItem } from "@similarweb/ui-components";
import styled from "styled-components";

export const StyledOptionDescription = styled.div`
    opacity: 0.6;
    width: inherit;
    overflow-wrap: anywhere;
    white-space: normal;
    font-size: 12px;
`;

export const StyledAddWebsitesDropdownItem = styled(EllipsisDropdownItem)`
    height: 100%;
    padding: 12px;
`;
